import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Button } from 'day8-ui';

import { TbAirConditioning } from "@react-icons/all-files/tb/TbAirConditioning";
import {
  getSelectedFilters, isFilterSelected, onFilterSelect
} from '../../../../helpers/filter';
import { capitalizeFirstLetter } from '../../../../helpers/utilities';
import { availableExtras } from '../../../../helpers/crewFinder';
import { FILTERS } from '../../../../constants';
import { useDispatch } from 'react-redux';

const Extras = props => {
  const dispatch = useDispatch();
  const selectedFilterText = getSelectedFilters(props.location)[FILTERS.EXTRAS].map(item => capitalizeFirstLetter(item)).join(', ');
  return props.mobile ? (
    <div className={props.className}>
      <div>
        <Checkbox
          label="Extras"
          onClick={e => onFilterSelect(props.location, dispatch, props.filterAction, FILTERS.EXTRAS, e.target.value)}
          options={availableExtras.map(amenity => ({
            label: capitalizeFirstLetter(amenity),
            value: amenity,
            checked: isFilterSelected(props.location, FILTERS.EXTRAS, amenity)
          }))}
        />
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<TbAirConditioning />}>{selectedFilterText || 'Extras'}</Button>;
};
Extras.propTypes = {
  location: PropTypes.object.isRequired,
  filterAction: PropTypes.func.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string
};
export default Extras;
